import React from 'react';

import { AccountScreenContainer, AccountScreenTitle } from '@order/components';
import { useLocalizationContext } from '@order/Localization';

import {
  SkeletonLoadingContentLG,
  SkeletonLoadingContentSM,
  SkeletonLoadingHeaderXS,
} from './AccountSkeletonLoading';

export const AccountReferFriendLoading = () => {
  const { t } = useLocalizationContext();

  return (
    <AccountScreenContainer screen="refer-friend">
      <AccountScreenTitle title={t('account.refer-friend.title')} />

      {/* Image */}
      <SkeletonLoadingContentLG />

      {/* Info */}
      <SkeletonLoadingHeaderXS />
      <SkeletonLoadingContentSM />

      {/* Share */}
      <SkeletonLoadingHeaderXS />
      <SkeletonLoadingContentSM />

      {/* Copy */}
      <SkeletonLoadingHeaderXS />
      <SkeletonLoadingContentSM />
    </AccountScreenContainer>
  );
};
